import { action, computed, makeObservable, observable } from 'mobx';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { soundService, soundTypes } from '../services/SoundService';

class DoBetStore {
  selectedAmount = 10;

  totalBet = 0;

  reBet = null;

  isBetAccepted = false;

  selectedOdd = 1.01;

  reBetAmount = 0;

  roundFinResult = null;

  roundIsFin = null;

  quickBets = [];

  constructor() {
    makeObservable(this, {
      quickBets: observable,
      selectedAmount: observable,
      selectedOdd: observable,
      roundFinResult: observable,
      roundIsFin: observable,
      isBetAccepted: observable,
      setDouble: action.bound,
      setHalve: action.bound,
      setQuickBets: action.bound,
      setSelectedAmount: action.bound,
      setSelectedOdd: action.bound,
      setRoundFinResult: action.bound,
      setRoundIsFin: action.bound,
      setIsBetAccepted: action.bound,
      limitsByBetType: computed,
    });
  }

  setSelectedAmount(value) {
    this.selectedAmount = value;
  }

  setSelectedOdd(oddValue) {
    this.selectedOdd = oddValue;
  }

  setRoundFinResult(result) {
    this.roundFinResult = result;
  }

  setRoundIsFin(boolean) {
    this.roundIsFin = boolean;
  }

  setIsBetAccepted(boolean) {
    this.isBetAccepted = boolean;
  }

  setDouble() {
    soundService.play(soundTypes.chip);
    if (this.selectedAmount * 2 > this.limitsByBetType.maxBet) {
      this.setSelectedAmount(this.limitsByBetType.maxBet);
    }
    if (this.selectedAmount * 2 <= this.limitsByBetType.maxBet) {
      this.setSelectedAmount(this.selectedAmount * 2);
    }
  }

  setHalve() {
    soundService.play(soundTypes.chip);
    if (this.selectedAmount / 2 < this.limitsByBetType.minBet) {
      this.setSelectedAmount(this.limitsByBetType.minBet);
    }
    if (this.selectedAmount / 2 >= this.limitsByBetType.minBet) {
      this.setSelectedAmount(this.selectedAmount / 2);
    }
  }

  get limitsByBetType() {
    const { limits } = gameConfigStore;
    return limits;
  }

  setQuickBets(quickBets) {
    this.quickBets = [...quickBets].reverse();
  }
}

export const doBetStore = new DoBetStore();
